import React from 'react'

export interface ScrollContextType {
  activityScrollOffset: number
  setActivityScrollOffset: (offset: number) => void
  accountsScrollOffset: number
  setAccountsScrollOffset: (offset: number) => void
}

export const ScrollContext = React.createContext<ScrollContextType>({
  activityScrollOffset: 0,
  setActivityScrollOffset: () => {},
  accountsScrollOffset: 0,
  setAccountsScrollOffset: () => {}
})
